import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
// import {LogoutURL} from '../../app-routing.module';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthGuard implements CanActivate {
    // URL = LogoutURL;
    constructor(private router: Router, private http: HttpClient) { }

    // getLogin(){
    //     this.http.get(this.URL).subscribe(res => {
    //         console.log(res);
    //     }, err => {
    //         console.error(err);
    //     });
    // }

    canActivate() {
        let key = sessionStorage.getItem('token');
        if (key != null) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}